module.exports = __webpack_public_path__ + "img/success.9592996a.png";